import {NinchatStoreRealm} from 'api/types/store'
import {RealmID} from 'api/types/properties'
import {useRealms} from './useRealms'

export const useRealm = (realmId: RealmID | undefined, fetchComplete = false): NinchatStoreRealm | undefined => useRealms([realmId], fetchComplete)[realmId ?? '']
